import React, { useState, useEffect } from 'react';
import { Layout, Card, Form, Input, Button, Typography, message, Switch, Divider, Row, Col, Space, Select, Tabs, Alert, Table, DatePicker, Tag, Modal, Descriptions, Tooltip, Grid } from 'antd';
import { 
  SettingOutlined, 
  SaveOutlined,
  BellOutlined,
  SecurityScanOutlined,
  UserOutlined,
  GlobalOutlined,
  KeyOutlined,
  TeamOutlined,
  ExclamationCircleOutlined,
  FileTextOutlined,
  SearchOutlined,
  FilterOutlined,
  ReloadOutlined,
  EyeOutlined,
  RobotOutlined,
  CheckCircleOutlined,
  SendOutlined,
  CustomerServiceOutlined,
  PlusOutlined,
  EditOutlined,
  DeleteOutlined
} from '@ant-design/icons';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';
import Navigation from '../components/Navigation';
import ModuleManager from '../components/ModuleManager';

const { Content } = Layout;
const { Title, Text } = Typography;
const { Option } = Select;
const { RangePicker } = DatePicker;
const { useBreakpoint } = Grid;

const Settings = () => {
  const screens = useBreakpoint();
  const isMobile = !screens.md;
  const [notificationsForm] = Form.useForm();
  const [portalForm] = Form.useForm();
  const [auditForm] = Form.useForm();
  const [loading, setLoading] = useState(false);
  const [user, setUser] = useState(null);
  const [auditLogs, setAuditLogs] = useState([]);
  const [auditLoading, setAuditLoading] = useState(false);
  const [auditPagination, setAuditPagination] = useState({
    current: 1,
    pageSize: 50,
    total: 0
  });
  const [auditFilters, setAuditFilters] = useState({
    actions: [],
    entityTypes: [],
    modules: []
  });
  const [selectedLog, setSelectedLog] = useState(null);
  const [logModalVisible, setLogModalVisible] = useState(false);
  const [objectDetails, setObjectDetails] = useState(null);
  const [loadingObjectDetails, setLoadingObjectDetails] = useState(false);
  const [telegramForm] = Form.useForm();
  const [telegramLoading, setTelegramLoading] = useState(false);
  const [macros, setMacros] = useState([]);
  const [macrosLoading, setMacrosLoading] = useState(false);
  const [macroModalOpen, setMacroModalOpen] = useState(false);
  const [editingMacro, setEditingMacro] = useState(null);
  const [macroForm] = Form.useForm();
  const [webhookStatus, setWebhookStatus] = useState(null);
  const navigate = useNavigate();

  const token = localStorage.getItem('token');

  useEffect(() => {
    console.log('🔄 Инициализация страницы настроек');
    console.log('🔑 Токен из localStorage:', token ? 'Есть' : 'Нет');
    
    if (!token) {
      console.log('❌ Токен отсутствует, перенаправляем на логин');
      navigate('/login');
      return;
    }
    
    console.log('✅ Токен найден, загружаем настройки пользователя');
    loadUserSettings();
  }, [token, navigate]);

  // Загружаем логи и фильтры только после загрузки пользователя
  useEffect(() => {
    if (user && token) {
      console.log('✅ Пользователь и токен загружены, загружаем логи и настройки');
      // Добавляем небольшую задержку для стабильности
      setTimeout(() => {
        loadAuditFilters();
        loadAuditLogs();
        loadTelegramSettings();
        loadMacros();
      }, 100);
    } else {
      console.log('⏳ Ожидаем загрузки пользователя и токена...', { user: !!user, token: !!token });
    }
  }, [user, token]);

  const loadUserSettings = async () => {
    try {
      console.log('Загружаем профиль пользователя...');
      console.log('Токен:', token ? 'Есть' : 'Нет');
      
      const response = await axios.get('https://limitverify.ru:5000/api/auth/profile', {
        headers: { Authorization: `Bearer ${token}` }
      });
      
      console.log('Ответ от сервера:', response.data);
      setUser(response.data.user);
      
      // Загружаем настройки пользователя
      const settingsResponse = await axios.get('https://limitverify.ru:5000/api/settings/user-settings', {
        headers: { Authorization: `Bearer ${token}` }
      });
      
      const settings = settingsResponse.data.settings;
      
      // Заполняем формы текущими настройками
      notificationsForm.setFieldsValue(settings.notifications);
      portalForm.setFieldsValue(settings.portal);
      
    } catch (error) {
      console.error('Ошибка загрузки настроек:', error);
      console.error('Статус ошибки:', error.response?.status);
      console.error('Данные ошибки:', error.response?.data);
      
      if (error.response?.status === 401) {
        message.error('Требуется авторизация. Перенаправление на страницу входа...');
        navigate('/login');
      } else if (error.response?.status === 403) {
        message.error('У вас нет прав для доступа к настройкам');
        navigate('/forbidden');
      } else {
        message.error('Ошибка загрузки данных пользователя');
      }
    }
  };

  const handleSaveNotifications = async () => {
    try {
      setLoading(true);
      const values = await notificationsForm.validateFields();
      
      await axios.put('https://limitverify.ru:5000/api/settings/user-settings', {
        notifications: values
      }, {
        headers: { Authorization: `Bearer ${token}` }
      });
      
      console.log('Сохранение настроек уведомлений:', values);
      message.success('Настройки уведомлений сохранены!');
      
    } catch (error) {
      console.error('Ошибка сохранения настроек уведомлений:', error);
      if (error.response?.status === 403) {
        message.error('У вас нет прав для изменения настроек');
      } else {
        message.error('Ошибка при сохранении настроек уведомлений');
      }
    } finally {
      setLoading(false);
    }
  };

  const handleSavePortal = async () => {
    try {
      setLoading(true);
      const values = await portalForm.validateFields();
      
      await axios.put('https://limitverify.ru:5000/api/settings/user-settings', {
        portal: values
      }, {
        headers: { Authorization: `Bearer ${token}` }
      });
      
      console.log('Сохранение настроек портала:', values);
      message.success('Настройки портала сохранены!');
      
    } catch (error) {
      console.error('Ошибка сохранения настроек портала:', error);
      if (error.response?.status === 403) {
        message.error('У вас нет прав для изменения настроек');
      } else {
        message.error('Ошибка при сохранении настроек портала');
      }
    } finally {
      setLoading(false);
    }
  };

  const loadMacros = async () => {
    try {
      setMacrosLoading(true);
      const response = await axios.get('https://limitverify.ru/api/tickets/macros', {
        headers: { Authorization: `Bearer ${token}` }
      });
      if (response.data.success) {
        setMacros(response.data.macros || []);
      }
    } catch (error) {
      console.error('Ошибка загрузки макросов:', error);
      message.error('Ошибка загрузки макросов');
    } finally {
      setMacrosLoading(false);
    }
  };

  const openMacroModal = (macro = null) => {
    setEditingMacro(macro);
    if (macro) {
      macroForm.setFieldsValue({ title: macro.title, body: macro.body });
    } else {
      macroForm.resetFields();
    }
    setMacroModalOpen(true);
  };

  const handleSaveMacro = async () => {
    try {
      const values = await macroForm.validateFields();
      if (editingMacro) {
        await axios.put(
          `https://limitverify.ru/api/tickets/macros/${editingMacro.id}`,
          values,
          { headers: { Authorization: `Bearer ${token}` } }
        );
        message.success('Макрос обновлён');
      } else {
        await axios.post(
          'https://limitverify.ru/api/tickets/macros',
          values,
          { headers: { Authorization: `Bearer ${token}` } }
        );
        message.success('Макрос создан');
      }
      setMacroModalOpen(false);
      setEditingMacro(null);
      macroForm.resetFields();
      loadMacros();
    } catch (error) {
      if (error?.errorFields) return;
      message.error(error?.response?.data?.error || 'Ошибка сохранения макроса');
    }
  };

  const handleDeleteMacro = (macro) => {
    Modal.confirm({
      title: 'Удалить макрос?',
      content: `«${macro.title}» будет удалён.`,
      okText: 'Удалить',
      okType: 'danger',
      cancelText: 'Отмена',
      onOk: async () => {
        try {
          await axios.delete(`https://limitverify.ru/api/tickets/macros/${macro.id}`, {
            headers: { Authorization: `Bearer ${token}` }
          });
          message.success('Макрос удалён');
          loadMacros();
        } catch (error) {
          message.error('Ошибка удаления макроса');
        }
      }
    });
  };

  // Функции для работы с Telegram ботом
  const loadTelegramSettings = async () => {
    try {
      console.log('Загружаем настройки Telegram...');
      
      const response = await axios.get('https://limitverify.ru/api/settings/telegram', {
        headers: { Authorization: `Bearer ${token}` }
      });
      
      if (response.data.success) {
        const settings = response.data.settings;
        console.log('Настройки Telegram загружены:', settings);
        
        // Устанавливаем значения в форму
        telegramForm.setFieldsValue({
          botToken: settings.botToken || '',
          botUsername: settings.botUsername || '',
          welcomeMessage: settings.welcomeMessage || 'Добро пожаловать! Отправьте серийный номер изделия для проверки.',
          autoReply: settings.autoReply !== undefined ? settings.autoReply : true
        });
      }
    } catch (error) {
      console.error('Ошибка загрузки настроек Telegram:', error);
      message.error('Ошибка загрузки настроек Telegram бота');
    }
  };

  const handleSaveTelegram = async () => {
    try {
      setTelegramLoading(true);
      const values = await telegramForm.validateFields();
      
      await axios.put('https://limitverify.ru/api/settings/telegram', values, {
        headers: { Authorization: `Bearer ${token}` }
      });
      
      message.success('Настройки Telegram бота сохранены!');
      
    } catch (error) {
      console.error('Ошибка сохранения настроек Telegram:', error);
      if (error.response?.status === 403) {
        message.error('У вас нет прав для изменения настроек');
      } else {
        message.error('Ошибка при сохранении настроек Telegram бота');
      }
    } finally {
      setTelegramLoading(false);
    }
  };

  const handleSetWebhook = async () => {
    try {
      setTelegramLoading(true);
      const values = await telegramForm.validateFields();
      
      const response = await axios.post('https://limitverify.ru/api/telegram/set-webhook', {
        botToken: values.botToken
      }, {
        headers: { Authorization: `Bearer ${token}` }
      });
      
      if (response.data.success) {
        message.success('Вебхук успешно установлен!');
        setWebhookStatus('connected');
      } else {
        message.error(response.data.error || 'Ошибка установки вебхука');
        setWebhookStatus('error');
      }
      
    } catch (error) {
      console.error('Ошибка установки вебхука:', error);
      message.error('Ошибка при установке вебхука');
      setWebhookStatus('error');
    } finally {
      setTelegramLoading(false);
    }
  };

  const handleCheckWebhook = async () => {
    try {
      setTelegramLoading(true);
      const values = await telegramForm.validateFields();
      
      const response = await axios.get('https://limitverify.ru/api/telegram/webhook-info', {
        headers: { Authorization: `Bearer ${token}` },
        params: { botToken: values.botToken }
      });
      
      if (response.data.success) {
        const webhookInfo = response.data.webhookInfo;
        if (webhookInfo.url) {
          message.success(`Вебхук установлен: ${webhookInfo.url}`);
          setWebhookStatus('connected');
        } else {
          message.warning('Вебхук не установлен');
          setWebhookStatus('disconnected');
        }
      } else {
        message.error(response.data.error || 'Ошибка проверки вебхука');
        setWebhookStatus('error');
      }
      
    } catch (error) {
      console.error('Ошибка проверки вебхука:', error);
      message.error('Ошибка при проверке вебхука');
      setWebhookStatus('error');
    } finally {
      setTelegramLoading(false);
    }
  };

  // Функции для работы с логами
  const loadAuditFilters = async () => {
    try {
      // Проверяем наличие токена
      if (!token) {
        return;
      }
      
      const response = await axios.get('https://limitverify.ru:5000/api/audit/filters', {
        headers: { Authorization: `Bearer ${token}` }
      });
      setAuditFilters(response.data);
    } catch (error) {
      console.error('Ошибка загрузки фильтров логов:', error);
      
      if (error.response?.status === 401 || error.response?.status === 403) {
        message.error('Требуется авторизация для загрузки фильтров');
        navigate('/login');
      }
    }
  };

  const loadAuditLogs = async (params = {}) => {
    try {
      setAuditLoading(true);
      
      // Проверяем наличие токена
      if (!token) {
        console.log('❌ Токен отсутствует при загрузке логов');
        message.error('Требуется авторизация');
        navigate('/login');
        return;
      }
      
      console.log('🔍 Загружаем логи с токеном:', token.substring(0, 20) + '...');
      
      const formValues = auditForm.getFieldsValue();
      
      const queryParams = {
        page: params.current || auditPagination.current,
        limit: params.pageSize || auditPagination.pageSize,
        ...formValues
      };

      // Обработка дат
      if (formValues.dateRange && formValues.dateRange.length === 2) {
        queryParams.startDate = formValues.dateRange[0].format('YYYY-MM-DD');
        queryParams.endDate = formValues.dateRange[1].format('YYYY-MM-DD');
        delete queryParams.dateRange;
      }

      const response = await axios.get('https://limitverify.ru:5000/api/audit/logs', {
        headers: { Authorization: `Bearer ${token}` },
        params: queryParams
      });

      setAuditLogs(response.data.logs);
      setAuditPagination({
        current: response.data.pagination.currentPage,
        pageSize: response.data.pagination.limit,
        total: response.data.pagination.totalCount
      });
    } catch (error) {
      console.error('❌ Ошибка загрузки логов:', error);
      console.error('❌ Статус ошибки:', error.response?.status);
      console.error('❌ Данные ошибки:', error.response?.data);
      
      if (error.response?.status === 401 || error.response?.status === 403) {
        console.log('🚨 Получена ошибка авторизации, перенаправляем на логин');
        message.error('Требуется авторизация. Перенаправление на страницу входа...');
        navigate('/login');
      } else {
        message.error('Ошибка загрузки логов');
      }
    } finally {
      setAuditLoading(false);
    }
  };

  const handleAuditSearch = () => {
    setAuditPagination(prev => ({ ...prev, current: 1 }));
    loadAuditLogs({ current: 1 });
  };

  const handleAuditReset = () => {
    auditForm.resetFields();
    setAuditPagination(prev => ({ ...prev, current: 1 }));
    loadAuditLogs({ current: 1 });
  };

  const showLogDetails = async (log) => {
    setSelectedLog(log);
    setLogModalVisible(true);
    setObjectDetails(null);
    
    // Загружаем детали объекта, если есть entityType и entityId
    if (log.entityType && log.entityId) {
      await loadObjectDetails(log.entityType, log.entityId);
    }
  };

  const loadObjectDetails = async (entityType, entityId) => {
    try {
      setLoadingObjectDetails(true);
      
      let endpoint = '';
      switch (entityType) {
        case 'PRODUCT':
          endpoint = `/api/products/${entityId}`;
          break;
        case 'USER':
          endpoint = `/api/admin/users/${entityId}`;
          break;
        case 'CLIENT':
          endpoint = `/api/clients/${entityId}`;
          break;
        default:
          setLoadingObjectDetails(false);
          return;
      }
      
      const response = await axios.get(`https://limitverify.ru:5000${endpoint}`, {
        headers: { Authorization: `Bearer ${token}` }
      });
      
      setObjectDetails(response.data);
    } catch (error) {
      console.error('Ошибка загрузки деталей объекта:', error);
      setObjectDetails({ error: 'Не удалось загрузить детали объекта' });
    } finally {
      setLoadingObjectDetails(false);
    }
  };

  const getActionColor = (action) => {
    const colors = {
      'CREATE': 'green',
      'UPDATE': 'blue',
      'DELETE': 'red',
      'LOGIN': 'cyan',
      'LOGOUT': 'orange',
      'EXPORT': 'purple',
      'IMPORT': 'magenta',
      'ASSIGN_ROLES': 'gold',
      'CHANGE_PASSWORD': 'volcano'
    };
    return colors[action] || 'default';
  };

  const getEntityTypeColor = (entityType) => {
    const colors = {
      'PRODUCT': 'blue',
      'USER': 'green',
      'CLIENT': 'orange',
      'MODULE': 'purple'
    };
    return colors[entityType] || 'default';
  };

  // Колонки таблицы логов
  const auditColumns = [
    {
      title: 'Время',
      dataIndex: 'timestamp',
      key: 'timestamp',
      width: 180,
      render: (timestamp) => new Date(timestamp).toLocaleString('ru-RU')
    },
    {
      title: 'Пользователь',
      dataIndex: 'userName',
      key: 'userName',
      width: 200,
      render: (userName, record) => (
        <div>
          <div>
            {userName}
            {record.performerType === 'CLIENT' && (
              <Tag color="orange" size="small" style={{ marginLeft: 8 }}>
                Клиент
              </Tag>
            )}
            {record.performerType === 'USER' && (
              <Tag color="blue" size="small" style={{ marginLeft: 8 }}>
                Сотрудник
              </Tag>
            )}
          </div>
          <Text type="secondary" style={{ fontSize: '12px' }}>
            {record.userEmail}
          </Text>
        </div>
      )
    },
    {
      title: 'Действие',
      dataIndex: 'action',
      key: 'action',
      width: 120,
      render: (action) => (
        <Tag color={getActionColor(action)}>
          {action}
        </Tag>
      )
    },
    {
      title: 'Тип объекта',
      dataIndex: 'entityType',
      key: 'entityType',
      width: 120,
      render: (entityType) => (
        <Tag color={getEntityTypeColor(entityType)}>
          {entityType}
        </Tag>
      )
    },
    {
      title: 'Объект',
      dataIndex: 'entityId',
      key: 'entityId',
      width: 150,
      render: (entityId, record) => (
        <div>
          <div>
            <Text code>{entityId}</Text>
          </div>
          <Text type="secondary" style={{ fontSize: '11px' }}>
            {record.entityType}
          </Text>
        </div>
      )
    },
    {
      title: 'IP адрес',
      dataIndex: 'ipAddress',
      key: 'ipAddress',
      width: 140
    },
    {
      title: 'Действия',
      key: 'actions',
      width: 100,
      render: (_, record) => (
        <Button
          type="link"
          icon={<EyeOutlined />}
          onClick={() => showLogDetails(record)}
        >
          Подробно
        </Button>
      )
    }
  ];

  if (!user) {
    return (
      <Layout style={{ minHeight: '100vh' }}>
        <Navigation />
        <Content style={{ padding: '24px', background: '#f0f2f5' }}>
          <div style={{ textAlign: 'center', padding: '50px' }}>
            <Text>Загрузка настроек...</Text>
          </div>
        </Content>
      </Layout>
    );
  }

  const tabItems = [
    {
      key: 'permissions',
      label: (
        <span>
          <KeyOutlined style={{ marginRight: 8 }} />
          Управление правами
        </span>
      ),
      children: (
        <div>
          <Alert
            message="Управление правами"
            description="Эта функция доступна только администраторам системы. Если у вас нет доступа, обратитесь к администратору."
            type="info"
            showIcon
            icon={<ExclamationCircleOutlined />}
            style={{ marginBottom: 16 }}
          />
          <ModuleManager />
        </div>
      )
    },
    {
      key: 'notifications',
      label: (
        <span>
          <BellOutlined style={{ marginRight: 8 }} />
          Настройки уведомлений
        </span>
      ),
      children: (
        <Card 
          title="Настройки уведомлений"
          extra={
            <Button 
              type="primary" 
              icon={<SaveOutlined />}
              loading={loading}
              onClick={handleSaveNotifications}
            >
              Сохранить
            </Button>
          }
        >
          <Form form={notificationsForm} layout="vertical">
            <Row gutter={[24, 0]}>
              <Col xs={24} md={12}>
                <Form.Item
                  name="emailNotifications"
                  label="Email уведомления"
                  valuePropName="checked"
                >
                  <Switch />
                </Form.Item>
              </Col>
              <Col xs={24} md={12}>
                <Form.Item
                  name="smsNotifications"
                  label="SMS уведомления"
                  valuePropName="checked"
                >
                  <Switch />
                </Form.Item>
              </Col>
            </Row>
            
            <Row gutter={[24, 0]}>
              <Col xs={24} md={12}>
                <Form.Item
                  name="telegramNotifications"
                  label="Telegram уведомления"
                  valuePropName="checked"
                >
                  <Switch />
                </Form.Item>
              </Col>
              <Col xs={24} md={12}>
                <Form.Item
                  name="pushNotifications"
                  label="Push уведомления"
                  valuePropName="checked"
                >
                  <Switch />
                </Form.Item>
              </Col>
            </Row>
          </Form>
        </Card>
      )
    },
    {
      key: 'portal',
      label: (
        <span>
          <GlobalOutlined style={{ marginRight: 8 }} />
          Настройки портала
        </span>
      ),
      children: (
        <Card 
          title="Настройки портала"
          extra={
            <Button 
              type="primary" 
              icon={<SaveOutlined />}
              loading={loading}
              onClick={handleSavePortal}
            >
              Сохранить
            </Button>
          }
        >
          <Form form={portalForm} layout="vertical">
            <Row gutter={[24, 0]}>
              <Col xs={24} md={12}>
                <Form.Item
                  name="language"
                  label="Язык интерфейса"
                >
                  <Select>
                    <Option value="ru">Русский</Option>
                    <Option value="en">English</Option>
                  </Select>
                </Form.Item>
              </Col>
              <Col xs={24} md={12}>
                <Form.Item
                  name="theme"
                  label="Тема оформления"
                >
                  <Select>
                    <Option value="light">Светлая</Option>
                    <Option value="dark">Темная</Option>
                    <Option value="auto">Автоматически</Option>
                  </Select>
                </Form.Item>
              </Col>
            </Row>

            <Row gutter={[24, 0]}>
              <Col xs={24} md={12}>
                <Form.Item
                  name="timezone"
                  label="Часовой пояс"
                >
                  <Select>
                    <Option value="Europe/Moscow">Москва (UTC+3)</Option>
                    <Option value="Europe/London">Лондон (UTC+0)</Option>
                    <Option value="America/New_York">Нью-Йорк (UTC-5)</Option>
                  </Select>
                </Form.Item>
              </Col>
              <Col xs={24} md={12}>
                <Form.Item
                  name="autoLogout"
                  label="Автоматический выход (минуты)"
                >
                  <Select>
                    <Option value={15}>15 минут</Option>
                    <Option value={30}>30 минут</Option>
                    <Option value={60}>1 час</Option>
                    <Option value={120}>2 часа</Option>
                    <Option value={0}>Никогда</Option>
                  </Select>
                </Form.Item>
              </Col>
            </Row>

            <Row gutter={[24, 0]}>
              <Col xs={24} md={12}>
                <Form.Item
                  name="twoFactorAuth"
                  label="Двухфакторная аутентификация"
                  valuePropName="checked"
                >
                  <Switch />
                </Form.Item>
              </Col>
            </Row>
          </Form>
        </Card>
      )
    },
    {
      key: 'audit',
      label: (
        <span>
          <FileTextOutlined style={{ marginRight: 8 }} />
          Логирование
        </span>
      ),
      children: (
        <Card 
          title="Журнал аудита"
          extra={
            <Space>
              <Button 
                icon={<ReloadOutlined />}
                onClick={() => loadAuditLogs()}
                loading={auditLoading}
              >
                Обновить
              </Button>
            </Space>
          }
        >
          {/* Фильтры */}
          <Card size="small" style={{ marginBottom: 16 }}>
            <Form form={auditForm} layout="inline" onFinish={handleAuditSearch}>
              <Row gutter={[16, 16]} style={{ width: '100%' }}>
                <Col xs={24} sm={12} md={6}>
                  <Form.Item name="dateRange" label="Период">
                    <RangePicker style={{ width: '100%' }} />
                  </Form.Item>
                </Col>
                <Col xs={24} sm={12} md={6}>
                  <Form.Item name="action" label="Действие">
                    <Select placeholder="Все действия" allowClear>
                      {auditFilters.actions.map(action => (
                        <Option key={action} value={action}>{action}</Option>
                      ))}
                    </Select>
                  </Form.Item>
                </Col>
                <Col xs={24} sm={12} md={6}>
                  <Form.Item name="entityType" label="Тип объекта">
                    <Select placeholder="Все типы" allowClear>
                      {auditFilters.entityTypes.map(type => (
                        <Option key={type} value={type}>{type}</Option>
                      ))}
                    </Select>
                  </Form.Item>
                </Col>
                <Col xs={24} sm={12} md={6}>
                  <Form.Item name="performerType" label="Тип пользователя">
                    <Select placeholder="Все типы" allowClear>
                      <Option value="USER">Сотрудник</Option>
                      <Option value="CLIENT">Клиент</Option>
                    </Select>
                  </Form.Item>
                </Col>
              </Row>
              <Row gutter={[16, 16]}>
                <Col xs={24} sm={12} md={6}>
                  <Form.Item name="search" label="Поиск">
                    <Input placeholder="IP, User-Agent, детали..." />
                  </Form.Item>
                </Col>
              </Row>
              <Row>
                <Col span={24}>
                  <Space>
                    <Button type="primary" htmlType="submit" icon={<SearchOutlined />}>
                      Поиск
                    </Button>
                    <Button onClick={handleAuditReset} icon={<FilterOutlined />}>
                      Сбросить
                    </Button>
                  </Space>
                </Col>
              </Row>
            </Form>
          </Card>

          {/* Таблица логов */}
          <Table
            columns={auditColumns}
            dataSource={auditLogs}
            rowKey="id"
            loading={auditLoading}
            pagination={{
              ...auditPagination,
              showSizeChanger: true,
              showQuickJumper: true,
              showTotal: (total, range) => 
                `${range[0]}-${range[1]} из ${total} записей`,
              onChange: (page, pageSize) => {
                loadAuditLogs({ current: page, pageSize });
              }
            }}
            scroll={{ x: 1200 }}
            size="small"
          />
        </Card>
      )
    },
    {
      key: 'telegram',
      label: (
        <span>
          <RobotOutlined style={{ marginRight: 8 }} />
          Telegram бот
        </span>
      ),
      children: (
        <Card 
          title="Настройки Telegram бота"
          extra={
            <Button 
              type="primary" 
              icon={<SaveOutlined />}
              loading={telegramLoading}
              onClick={handleSaveTelegram}
            >
              Сохранить
            </Button>
          }
        >
          <Form form={telegramForm} layout="vertical">
            <Row gutter={[24, 0]}>
              <Col xs={24} md={12}>
                <Form.Item
                  name="botToken"
                  label="Токен бота"
                  rules={[
                    { required: true, message: 'Введите токен бота' },
                    { pattern: /^\d+:[A-Za-z0-9_-]+$/, message: 'Неверный формат токена' }
                  ]}
                >
                  <Input.Password 
                    placeholder="123456789:ABCdefGHIjklMNOpqrsTUVwxyz"
                    addonBefore="@"
                  />
                </Form.Item>
              </Col>
              <Col xs={24} md={12}>
                <Form.Item
                  name="botUsername"
                  label="Имя пользователя бота"
                  rules={[{ required: true, message: 'Введите имя пользователя бота' }]}
                >
                  <Input 
                    placeholder="my_company_bot"
                    addonBefore="@"
                  />
                </Form.Item>
              </Col>
            </Row>

            <Row gutter={[24, 0]}>
              <Col xs={24} md={12}>
                <Form.Item
                  name="welcomeMessage"
                  label="Приветственное сообщение"
                >
                  <Input.TextArea 
                    rows={3}
                    placeholder="Добро пожаловать! Отправьте серийный номер изделия для проверки."
                  />
                </Form.Item>
              </Col>
              <Col xs={24} md={12}>
                <Form.Item
                  name="autoReply"
                  label="Автоответ"
                  valuePropName="checked"
                >
                  <Switch />
                </Form.Item>
              </Col>
            </Row>

            <Divider />

            <Row gutter={[16, 16]}>
              <Col span={24}>
                <Text strong>Управление вебхуком</Text>
                <br />
                <Text type="secondary">
                  Вебхук позволяет боту получать сообщения в реальном времени
                </Text>
              </Col>
              <Col>
                <Space>
                  <Button 
                    type="primary" 
                    icon={<SendOutlined />}
                    loading={telegramLoading}
                    onClick={handleSetWebhook}
                  >
                    Установить вебхук
                  </Button>
                  <Button 
                    icon={<CheckCircleOutlined />}
                    loading={telegramLoading}
                    onClick={handleCheckWebhook}
                  >
                    Проверить вебхук
                  </Button>
                </Space>
              </Col>
              {webhookStatus && (
                <Col span={24}>
                  {webhookStatus === 'connected' && (
                    <Alert
                      message="Вебхук установлен"
                      description="Бот готов к приему сообщений"
                      type="success"
                      showIcon
                    />
                  )}
                  {webhookStatus === 'disconnected' && (
                    <Alert
                      message="Вебхук не установлен"
                      description="Установите вебхук для работы бота"
                      type="warning"
                      showIcon
                    />
                  )}
                  {webhookStatus === 'error' && (
                    <Alert
                      message="Ошибка вебхука"
                      description="Проверьте настройки бота и попробуйте снова"
                      type="error"
                      showIcon
                    />
                  )}
                </Col>
              )}
            </Row>
          </Form>
        </Card>
      )
    },
    {
      key: 'tickets',
      label: (
        <span>
          <CustomerServiceOutlined style={{ marginRight: 8 }} />
          Управление тикетами
        </span>
      ),
      children: (
        <Card
          title="Макросы ответов"
          extra={
            <Button type="primary" icon={<PlusOutlined />} onClick={() => openMacroModal()}>
              Добавить макрос
            </Button>
          }
        >
          <Alert
            type="info"
            showIcon
            style={{ marginBottom: 16 }}
            message="Макросы подставляются в ответ оператора в разделе Поддержка."
          />
          <Table
            rowKey="id"
            loading={macrosLoading}
            dataSource={macros}
            pagination={false}
            columns={[
              {
                title: 'Название',
                dataIndex: 'title',
                key: 'title',
                width: 220
              },
              {
                title: 'Текст',
                dataIndex: 'body',
                key: 'body',
                render: (body) => (
                  <Text style={{ whiteSpace: 'pre-wrap' }}>
                    {body?.length > 160 ? `${body.slice(0, 160)}…` : body}
                  </Text>
                )
              },
              {
                title: 'Действия',
                key: 'actions',
                width: 200,
                render: (_, record) => (
                  <Space>
                    <Button icon={<EditOutlined />} onClick={() => openMacroModal(record)}>
                      Изменить
                    </Button>
                    <Button danger icon={<DeleteOutlined />} onClick={() => handleDeleteMacro(record)}>
                      Удалить
                    </Button>
                  </Space>
                )
              }
            ]}
            locale={{ emptyText: 'Нет макросов' }}
          />
        </Card>
      )
    }
  ];

  return (
    <Layout style={{ minHeight: '100vh' }}>
      <Navigation />
      
      <Content style={{ padding: isMobile ? '12px' : '24px', background: '#f0f2f5' }}>
        <div style={{ maxWidth: '1200px', margin: '0 auto' }}>
          {/* Заголовок */}
          <div style={{ marginBottom: isMobile ? 16 : 24 }}>
            <Title level={isMobile ? 3 : 2} style={{ marginBottom: 4 }}>
              <SettingOutlined style={{ marginRight: 8 }} />
              Настройки
            </Title>
            <Text type="secondary">Управление настройками аккаунта и системы</Text>
          </div>

          {/* Вкладки */}
          <Tabs 
            defaultActiveKey="permissions" 
            items={tabItems}
            size={isMobile ? 'middle' : 'large'}
            style={{ background: '#fff', padding: isMobile ? '12px' : '24px', borderRadius: '8px' }}
          />
        </div>
      </Content>

      {/* Модальное окно макроса */}
      <Modal
        title={editingMacro ? 'Редактировать макрос' : 'Новый макрос'}
        open={macroModalOpen}
        onCancel={() => {
          setMacroModalOpen(false);
          setEditingMacro(null);
          macroForm.resetFields();
        }}
        onOk={handleSaveMacro}
        okText="Сохранить"
        cancelText="Отмена"
        destroyOnClose
      >
        <Form form={macroForm} layout="vertical">
          <Form.Item
            name="title"
            label="Название"
            rules={[{ required: true, message: 'Укажите название' }]}
          >
            <Input placeholder="Например: Нужны фото" maxLength={200} />
          </Form.Item>
          <Form.Item
            name="body"
            label="Текст ответа"
            rules={[{ required: true, message: 'Укажите текст' }]}
          >
            <Input.TextArea rows={6} placeholder="Текст, который подставится в ответ клиенту" />
          </Form.Item>
        </Form>
      </Modal>

      {/* Модальное окно для детального просмотра лога */}
      <Modal
        title={
          <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
            <FileTextOutlined />
            Детали записи аудита
            {selectedLog && (
              <Tag color={getActionColor(selectedLog.action)}>
                {selectedLog.action}
              </Tag>
            )}
          </div>
        }
        open={logModalVisible}
        onCancel={() => {
          setLogModalVisible(false);
          setObjectDetails(null);
        }}
        footer={[
          <Button key="close" onClick={() => {
            setLogModalVisible(false);
            setObjectDetails(null);
          }}>
            Закрыть
          </Button>
        ]}
        width={1000}
      >
        {selectedLog && (
          <div>
            {/* Основная информация */}
            <Card title="Основная информация" size="small" style={{ marginBottom: 16 }}>
              <Descriptions bordered column={2} size="small">
                <Descriptions.Item label="ID записи" span={1}>
                  <Text code>{selectedLog.id}</Text>
                </Descriptions.Item>
                <Descriptions.Item label="Время" span={1}>
                  <Text strong>{new Date(selectedLog.timestamp).toLocaleString('ru-RU')}</Text>
                </Descriptions.Item>
                <Descriptions.Item label="Пользователь" span={2}>
                  <div>
                    <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                      <Text strong>{selectedLog.userName}</Text>
                      {selectedLog.performerType === 'CLIENT' && (
                        <Tag color="orange" size="small">Клиент</Tag>
                      )}
                      {selectedLog.performerType === 'USER' && (
                        <Tag color="blue" size="small">Сотрудник</Tag>
                      )}
                    </div>
                    <Text type="secondary" style={{ fontSize: '12px' }}>
                      {selectedLog.userEmail}
                    </Text>
                  </div>
                </Descriptions.Item>
                <Descriptions.Item label="Тип объекта" span={1}>
                  <Tag color={getEntityTypeColor(selectedLog.entityType)}>
                    {selectedLog.entityType}
                  </Tag>
                </Descriptions.Item>
                <Descriptions.Item label="ID объекта" span={1}>
                  <Text code>{selectedLog.entityId}</Text>
                </Descriptions.Item>
              </Descriptions>
            </Card>

            {/* Информация об объекте */}
            {selectedLog.entityType && selectedLog.entityId && (
              <Card 
                title="Информация об объекте" 
                size="small" 
                style={{ marginBottom: 16 }}
                loading={loadingObjectDetails}
              >
                {objectDetails ? (
                  objectDetails.error ? (
                    <Alert message={objectDetails.error} type="warning" />
                  ) : (
                    <div>
                      {selectedLog.entityType === 'PRODUCT' && objectDetails.product && (
                        <Descriptions bordered column={2} size="small">
                          <Descriptions.Item label="Название" span={2}>
                            <Text strong>{objectDetails.product.name}</Text>
                          </Descriptions.Item>
                          <Descriptions.Item label="Серийный номер" span={1}>
                            <Text code>{objectDetails.product.serialNumber}</Text>
                          </Descriptions.Item>
                          <Descriptions.Item label="Идентификационный номер" span={1}>
                            <Text code>{objectDetails.product.identificationNumber}</Text>
                          </Descriptions.Item>
                          <Descriptions.Item label="Статус" span={1}>
                            <Tag color={objectDetails.product.status === 'АКТИВНО' ? 'green' : 'red'}>
                              {objectDetails.product.status}
                            </Tag>
                          </Descriptions.Item>
                          <Descriptions.Item label="Дата выпуска" span={1}>
                            {objectDetails.product.releaseDate}
                          </Descriptions.Item>
                        </Descriptions>
                      )}
                      {selectedLog.entityType === 'USER' && objectDetails.user && (
                        <Descriptions bordered column={2} size="small">
                          <Descriptions.Item label="Имя" span={2}>
                            <Text strong>{objectDetails.user.fullName}</Text>
                          </Descriptions.Item>
                          <Descriptions.Item label="Email" span={1}>
                            {objectDetails.user.email}
                          </Descriptions.Item>
                          <Descriptions.Item label="Статус" span={1}>
                            <Tag color={objectDetails.user.isActive ? 'green' : 'red'}>
                              {objectDetails.user.isActive ? 'Активен' : 'Неактивен'}
                            </Tag>
                          </Descriptions.Item>
                        </Descriptions>
                      )}
                      {selectedLog.entityType === 'CLIENT' && objectDetails.client && (
                        <Descriptions bordered column={2} size="small">
                          <Descriptions.Item label="Имя" span={2}>
                            <Text strong>{objectDetails.client.fullName}</Text>
                          </Descriptions.Item>
                          <Descriptions.Item label="Email" span={1}>
                            {objectDetails.client.email}
                          </Descriptions.Item>
                          <Descriptions.Item label="Телефон" span={1}>
                            {objectDetails.client.phone || 'Не указан'}
                          </Descriptions.Item>
                        </Descriptions>
                      )}
                    </div>
                  )
                ) : (
                  <Text type="secondary">Загрузка информации об объекте...</Text>
                )}
              </Card>
            )}

            {/* Техническая информация */}
            <Card title="Техническая информация" size="small" style={{ marginBottom: 16 }}>
              <Descriptions bordered column={2} size="small">
                <Descriptions.Item label="IP адрес" span={1}>
                  <Text code>{selectedLog.ipAddress}</Text>
                </Descriptions.Item>
                <Descriptions.Item label="Модуль" span={1}>
                  <Tag>{selectedLog.moduleName || 'Не указан'}</Tag>
                </Descriptions.Item>
                <Descriptions.Item label="Endpoint" span={2}>
                  <Text code>{selectedLog.endpoint || 'Не указан'}</Text>
                </Descriptions.Item>
                <Descriptions.Item label="User-Agent" span={2}>
                  <Tooltip title={selectedLog.userAgent}>
                    <Text ellipsis style={{ maxWidth: 400 }}>
                      {selectedLog.userAgent}
                    </Text>
                  </Tooltip>
                </Descriptions.Item>
              </Descriptions>
            </Card>

            {/* Детали изменений */}
            <Card title="Детали изменений" size="small">
              <pre style={{ 
                background: '#f8f9fa', 
                padding: '12px', 
                borderRadius: '6px',
                fontSize: '12px',
                maxHeight: '300px',
                overflow: 'auto',
                border: '1px solid #e9ecef',
                fontFamily: 'Monaco, Menlo, "Ubuntu Mono", monospace'
              }}>
                {JSON.stringify(selectedLog.details, null, 2)}
              </pre>
            </Card>
          </div>
        )}
      </Modal>
    </Layout>
  );
};

export default Settings;
